import { render, staticRenderFns } from "./CentroCusto.vue?vue&type=template&id=c05369c8"
import script from "./CentroCusto.vue?vue&type=script&lang=js"
export * from "./CentroCusto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports